import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export default function getInterventionsFromList(idList) {
  return Client.post(
    `${process.env.P2C_BASE_URI}/properties/interventions_in_progress`,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.interventions;
    })
    .catch(errorHandler);
}
